import { Paper, Typography } from "@mui/material";

export default function WhyWalletTransfer() {
  return (
    <Paper sx={{ p: 3, borderRadius: 3, bgcolor: "#0c1222", color: "white" }}>
      <Typography fontWeight={600} mb={2}>
        Why Wallet Transfer?
      </Typography>

      <Typography fontSize={14} fontWeight={600}>
        ✓ Zero Fee Transfer
      </Typography>
      <Typography fontSize={12} color="#9aa0a6" mb={2}>
        Transfer money without service charges.
      </Typography>

      <Typography fontSize={14} fontWeight={600}>
        ✓ Instant Settlement
      </Typography>
      <Typography fontSize={12} color="#9aa0a6">
        Funds are credited instantly, 24/7.
      </Typography>
    </Paper>
  );
}
